<template>
    <div class="customer-flow-form" style="position: relative; border-bottom: 1px solid #eee">
        <div
            v-if="canDelete"
            class="customer-flow-form__detele"
            style="position: absolute; right: 0; top: 0; z-index: 1000"
        >
            <button
                type="button"
                class="button users-repeater-item__delete"
                @click.prevent="$emit('delete', modelValue)"
            >
                <IconCross />
            </button>
        </div>
        <Grid gap-y="10">
            <Column>
                <FormField
                    v-if="schema.flow"
                    name="flow.flow"
                    :label="schema.flow.label"
                    :required="schema.flow.required"
                    :error="error"
                >
                    <CustomSelect
                        v-model="localFlow.flow"
                        style="width: 100%; max-width: 360px"
                        :form-value-text="(item) => item.label[$i18n.locale]"
                        emit-prop="id"
                        :options="flows"
                    >
                        <template #default="{ item }">
                            {{ item.label[$i18n.locale] }}
                        </template>
                    </CustomSelect>
                </FormField>
            </Column>
        </Grid>
        <Grid>
            <Column gap-y="10">
                <FormField
                    name="flow.role"
                    :label="schema.role.label"
                    :required="schema.role.required"
                    :error="error"
                >
                    <CustomSelect
                        v-model="localFlow.role"
                        style="width: 100%; max-width: 360px"
                        :form-value-text="(item) => item.display_name"
                        emit-prop="value"
                        :options="schema.role.choices"
                    >
                        <template #default="{ item }">
                            {{ item.display_name }}
                        </template>
                    </CustomSelect>
                </FormField>
            </Column>
            <Column gap-y="10">
                <FormField
                    name="flow.type_production"
                    :label="schema.type_productions.label"
                    :required="schema.type_productions.required"
                    :error="error"
                >
                    <CustomSelect
                        v-model="localFlow.type_productions"
                        style="width: 100%; max-width: 360px"
                        :form-value-text="(item) => item.display_name"
                        emit-prop="value"
                        :options="schema.type_productions.choices"
                    >
                        <template #default="{ item }">
                            {{ item.display_name }}
                        </template>
                    </CustomSelect>
                </FormField>
            </Column>
        </Grid>
        <Grid>
            <Column>
                <FormField name="flow.roles" :error="error">
                    <Checkbox v-model="localFlow.is_integration">
                        {{ schema.is_integration.label }}
                    </Checkbox>
                </FormField>
            </Column>
            <Column>
                <FormField name="flow.roles" :error="error">
                    <Checkbox v-model="localFlow.is_main">
                        {{ schema.is_main.label }}
                    </Checkbox>
                </FormField>
            </Column>
        </Grid>
    </div>
</template>

<script>
import { Checkbox, FormField, CustomSelect } from '@speechki-frontend/shared/ui/forms';
import { Grid, Column } from '@speechki-frontend/shared/ui/Grid';
import { IconCross } from '@speechki-frontend/shared/ui/icons';

export default {
    name: 'CustomerFlowForm',
    components: {
        Checkbox,
        FormField,
        Grid,
        Column,
        IconCross,
        CustomSelect,
    },
    props: {
        schema: {
            type: Object,
            required: true,
        },
        modelValue: {
            type: Object,
            default: () => ({}),
        },
        canDelete: {
            type: Boolean,
            default: true,
        },
        flows: {
            type: Array,
            default: () => [],
        },
        error: {
            type: Object,
            default: () => {},
        },
    },
    emits: ['update:modelValue', 'delete'],
    data() {
        return {
            localFlow: this.modelValue ? { ...this.modelValue } : {},
        };
    },
    watch: {
        modelValue(val) {
            this.localFlow = val ? { ...val } : {};
        },
        localFlow: {
            deep: true,
            handler(val) {
                this.$emit('update:modelValue', val);
            },
        },
    },
};
</script>
